import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const Editable = ({
  childRef,
  text,
  type,
  placeholder,
  children,
  ...props
}) => {
  const [isEditing, setEditing] = useState(false);

  const handleKeyDown = (event, type) => {
    if (event.keyCode === 13) setEditing(false);
  };

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  return (
    <section {...props}>
      {isEditing ? (
        <div
          onBlur={() => setEditing(false)}
          onKeyDown={(e) => handleKeyDown(e, type)}
        >
          {children}
        </div>
      ) : (
        <div onClick={() => setEditing(true)} className="u--display-flex">
          <span className="u--font-size-lg u--margin-right-5">
            {text || placeholder || 'Editable content'}
          </span>
          <FontAwesomeIcon
            icon={faPencilAlt}
            className="group-input__pencil-icon"
          />
        </div>
      )}
    </section>
  );
};

export default Editable;
